import ChildAuditPage from './ChildAuditPage'
export default ChildAuditPage


// WEBPACK FOOTER //
// ./src/pages/child/audit/index.js